<template>
  <div class="read-setting">
    <div class="item">
      <div class="label">字体大小：</div>
      <a-slider class="slider" v-model:value="fontsize" dots :marks="marks" :min="12" :max="20" :step="2" />
    </div>

    <div class="footer">
      <a-button @click="$emit('close')">取消</a-button>
      <a-button type="primary" @click="setReadSetting({ fontsize }); $emit('close')">确认</a-button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'read-setting',
  data() {
    return {
      fontsize: 16,
      marks: {
        12: '极小',
        14: '小',
        16: '默认',
        18: '大',
        20: '极大',
      }
    }
  },
  computed: {
    ...mapState({
      readSetting: state => state.readSetting,
    }),
  },
  watch: {
    readSetting() {
      if (this.readSetting.fontsize) this.fontsize = this.readSetting.fontsize
    },
  },
  methods: {
    ...mapMutations({
      setReadSetting: 'setReadSetting',
    }),
  },
}
</script>

<style scoped lang="scss">
.read-setting {
  :deep(.ant-slider-track) {
    background-color: #f78c9d !important;
  }

  :deep(.ant-slider-handle:not(.ant-tooltip-open)) {
    border-color: #f78c9d !important;
  }

  :deep(.ant-slider-mark) {
    font-size: 12px;
    top: 16px;
  }
}

.item {
  margin-bottom: 22px;
}

.label {
  margin-bottom: 10px;
}

.slider {
  width: 92%;
  margin: 0 auto;
}

.footer {
  border-top: 1px solid #f0f0f0;
  margin: 50px -24px -12px;
  padding: 12px 24px 0;
  text-align: right;

  button {
    margin-left: 10px;
  }
}
</style>